import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import {
    SWAL_SETTINGS,
    PHONE_NO_LENGTH,
    ROLE,
} from "../../../../utils/Constants";
import {
    handleServerValidations,
    globalLoader,
    capitalizeFirstLetter,
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { useTranslation } from "react-i18next";
import { TagPicker } from "rsuite";
import PhoneInput from "../../../../utils/PhoneInput";
import { PHONE_VALIDATION } from "../../../../utils/commonValidations";
import * as coachServices from "../../services/common.services";
import { SpecializationList } from "../../services/coach-specialization.services";
import { GetAllCenters } from "../../services/usermgmt.services";
import Select from 'react-select';

const AddCoach = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [saveType, setSaveType] = useState("");
    const [specialization, setSpecialization] = useState([]);
    const [specializationData, setSpecializationData] = useState([]);
    const [showOtherSpecialisation, setShowOtherSpecialization] = useState(false);
    const [centers, setCenters] = useState([]);

    const breadcrumbs = [
        { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
        {
            title: t("Coach Management"),
            url: "/admin/coach-management/list/1",
        },
        { title: t("admin.cafes.link_add"), url: "" },
    ];

    useEffect(() => {
        SpecializationList(ROLE.SUPER_ADMIN)
            .then((data) => {
                setSpecialization(data?.data?.list || []);

                const dropdownData = data?.data?.list?.map((item) => ({
                    label: capitalizeFirstLetter(item?.title),
                    value: item?._id,
                }));
                dropdownData.push({label: 'other', value: 'other'});

                setSpecializationData(dropdownData);
                 
            })
            .catch((error) => {
                console.log("error ====> ", error);
            });
    }, []);

    useEffect(() => {
        GetAllCenters()
            .then((data) => {
                setCenters(data && data.data ? data.data : []);
            })
            .catch((error) => {
                console.log("error ====> ", error);
            });
    }, []);


    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .trim()
            .min(3, "Coach name must be at least 3 characters.")
            .max(40, "Coach name must not be more than 40 characters.")
            .matches(/^[a-zA-Z\s&\-'.]+$/, "Coach name can only contain letters, spaces, and common punctuation.")
            .required("Coach name is required"),
        email: Yup.string()
            .trim()
            .email("admin.cafes.label_email_invalid_format_error")
            .matches(/^(?!\.)(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, "admin.cafes.label_email_invalid_format_error"),
        phone_number: PHONE_VALIDATION,
        experience_years: Yup.number()
            .required("Experience(years) is required")
            .integer("Experience(years) must be an integer")
            .min(0, "Experience(years) cannot be negative")
            .max(9999, "Experience(years) cannot be more than 4 digits"),
        // experience_months: Yup.number()
        //     .required("Experience(months) is required")
        //     .integer("Experience(months) must be an integer")
        //     .min(0, "Experience(months) cannot be negative")
        //     .max(9999, "Experience(months) cannot be more than 4 digits"),
        specialization: Yup.array()
            .min(1, "Specialization is required")
            .required("Specialization is required"),
        other_specialisation: Yup.string().trim(),
        center: Yup.string().trim().required("Centre is required"),
    });

    const formik = useFormik({
        initialValues: {
            name: "",
            email: "",
            phone_number: "",
            specialization: [],
            other_specialisation: "",
            experience_months: '',
            experience_years: "",
            center: "",
        },
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            globalLoader(true);
            let formData = new FormData();
            formData.append("name", values.name);
            formData.append("email", values.email.toLowerCase());
            formData.append("phone_number", values.phone_number);
            formData.append("experience_months", values.experience_months);
            formData.append("experience_years", values.experience_years);

            const filteredSpecialisation = values.specialization?.filter(item => item!='other');
            formData.append("specialisation", JSON.stringify(filteredSpecialisation));
            formData.append("other_specialisation", values.other_specialisation);

            formData.append("center_id", values.center);

            coachServices.Add(formData, ROLE.SUPER_ADMIN)
                .then((response) => {
                    setSubmitting(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        if (saveType !== "Save") {
                            navigate(`/admin/coach-management/list/1`);
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                    globalLoader(false);
                })
                .catch((error) => {
                    Swal.fire({
                        icon: "error",
                        text: handleServerValidations(error),
                        ...SWAL_SETTINGS,
                    });
                    console.log("error ====> ", error);
                });
        },
    });

    const centerOptions = centers.map((item) => ({
        value: item._id,
        label: `${capitalizeFirstLetter(item.center_name)}${item.city ? ` (${capitalizeFirstLetter(item.city)})` : ''}`
    }));

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <form onSubmit={formik.handleSubmit}>
                <div className="row row-sm">
                    <div className="col-lg-12 col-md-12 animation_fade">
                        <div className="card custom-card">
                            <div className="card-body">
                                <h6 className="main-content-label mb-3">{t("Add Coach")}</h6>
                                <div className="row row-sm">
                                    {/* Name */}
                                    <div className="col-md-6 form-group">
                                        <label className="text-left d-flex">{t("Name")}:<span className="requirestar">*</span></label>
                                        <input
                                            name="name"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.name}
                                            className="form-control"
                                            placeholder={t("Enter name")}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="name" form={formik} />
                                        </span>
                                    </div>

                                    {/* Email */}
                                    <div className="col-md-6 form-group">
                                        <label className="text-left d-flex">{t("Email")}:</label>
                                        <input
                                            name="email"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.email}
                                            className="form-control"
                                            placeholder={t("Enter email")}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="email" form={formik} />
                                        </span>
                                    </div>

                                    {/* Phone */}
                                    <div className="col-md-6 form-group">
                                        <label className="text-left d-flex">{t("Phone Number")}:<span className="requirestar">*</span></label>
                                        <PhoneInput
                                            name="phone_number"
                                            placeholder={t('Enter phone number')}
                                            onChange={(e) => formik.setFieldValue('phone_number', e?.phone_number)}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.phone_number}
                                            className="form-control"
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="phone_number" form={formik} shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }}/>
                                        </span>
                                    </div>

                                    {/* Specialization */}
                                    <div className="col-md-6 form-group">
                                        <label className="text-left d-flex">{t("Specialization")}:<span className="requirestar">*</span></label>
                                        <TagPicker
                                            data={specializationData}
                                            onChange={(e) => {
                                                formik.setFieldValue("specialization", e);

                                                if(e.includes('other'))setShowOtherSpecialization(true);
                                                else setShowOtherSpecialization(false);
                                            }}
                                            value={formik.values.specialization}
                                            className="w-100"
                                            cleanable={false}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="specialization" form={formik} />
                                        </span>
                                    </div>

                                    {
                                        showOtherSpecialisation
                                        ? <div className="col-lg-3 text-center form-group">
                                            <label className="text-left d-flex">
                                                {t("Other Specialisation")}:
                                                {/* <span className="requirestar">*</span> */}
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={t("Enter other specialisation")}
                                                name="other_specialisation"
                                                value={formik?.values?.other_specialisation}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            {/* <span className="text-danger d-flex text-left">
                                                <CustomError name="experience_years" form={formik} className="text-danger" />
                                            </span> */}
                                        </div>
                                        : null
                                    }

                                    {/* Experience */}
                                    <div className="col-md-3 form-group">
                                        <label className="text-left d-flex">{t("Experience (Years)")}:<span className="requirestar">*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="experience_years"
                                            placeholder={t("Enter experience in years")}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.experience_years}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="experience_years" form={formik} />
                                        </span>
                                    </div>

                                    <div className="col-md-3 form-group">
                                        <label className="text-left d-flex">{t("Experience (Months)")}:</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="experience_months"
                                            placeholder={t("Enter experience in months")}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.experience_months}
                                        />
                                        {/* <span className="text-danger d-flex text-left">
                                            <CustomError name="experience_months" form={formik} />
                                        </span> */}
                                    </div>

                                    <div className="col-md-6 text-center form-group">
                                        <label className="text-left d-flex">
                                            Centre:
                                            <span className="requirestar">*</span>
                                        </label>

                                        <Select
                                            className="cp"
                                            name="center"
                                            options={centerOptions}
                                            value={centerOptions.find(option => option.value === formik.values.center)}
                                            onChange={selectedOption => formik.setFieldValue('center', selectedOption?.value)}
                                            onBlur={() => formik.setFieldTouched('center', true)}
                                            placeholder={t("Select")}
                                            isSearchable={true}
                                            noOptionsMessage={() => t("No centres found")}
                                        />

                                        {formik.touched.center && formik.errors.center ? (
                                            <div className="text-danger d-flex text-left">{t(formik.errors.center)}</div>
                                        ) : null}
                                    </div>

                                    {/* Buttons */}
                                    <div className="mt-5">
                                        <button
                                            onClick={() => setSaveType("Save")}
                                            className="btn btn-info mr-2"
                                            type="submit"
                                        >
                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                            {t("admin.button.btn_save")}
                                        </button>
                                        <button
                                            onClick={() => setSaveType("")}
                                            className="btn btn-success mr-2"
                                            type="submit"
                                        >
                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                            {t("admin.button.btn_save_exit")}
                                        </button>
                                        <button
                                            className="btn ripple btn-secondary"
                                            type="button"
                                            onClick={() => navigate(-1)}
                                        >
                                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                            {t("admin.button.btn_cancel")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddCoach;
